/* eslint-disable  @typescript-eslint/no-explicit-any */

/** Возможность добавить скругления для первого или последнего фильтра в строке */

/** Пропсы для фильтров, обогащенные базовыми пропсами */

/**
 * Интерфейсы для базовых фильтров:
 *   * IFilterUI - фильтр-переключатель, подходит для группы кнопок
 * */
export var dropdownSeparator = Symbol();